<template>
    <Dialog class="dialog_wrap" width="60%" v-model="previeVisible" title="报告" top="5vh">
        <previewReportV2 :organizationId="organizationId" :name="name"></previewReportV2>  
    </Dialog>
</template>

<script setup>
import {ref } from "vue";
import previewReportV2 from "./previewReportV2.vue";

const organizationId = ref('')
const name = ref('')
const previeVisible = ref(false);
const openPrevieDialog = (row)=>{
    organizationId.value = row.organizationId
    name.value = row.organizationName
    previeVisible.value = true 
}

defineExpose({
    openPrevieDialog
})
</script>
<style scoped lang="scss">
.dialog_wrap{
    display: flex;
    justify-content: center;
}
</style>
